const B_1 = [
    {
        title: '提交工单',
        path: '/manage/business/xgsq/list'
    }
]

export default {
    path: 'xgsq',
    component: () => import(/*webpackChunkName: 'manage-business-xgsq'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'manage-business-xgsq'*/'@views/manage/views/business/xgsq/list'),
            meta: {
                title: '工单列表',
                bread: B_1,
                topNav: true
            },
        },
        {
            path:"form",
            component: () => import(/*webpackChunkName: 'manage-business-xgsq'*/'@views/manage/views/business/xgsq/form'),
            meta: {
                title: '工单申请',
                bread: [
                    ...B_1,
                    {
                        title: '工单申请',
                        path: '/manage/business/xgsq/form'
                    },
                ]
                
            },
        },
        {
            path:"detail",
            component: () => import('@views/manage/views/business/xgsq/detail'),
            meta: {
                title: '工单详情',
                bread: [
                    ...B_1,
                    {
                        title: '工单详情',
                        path: '/manage/business/xgsq/detail'
                    },
                ]
            },
        }
    ]
}
